const Reactaux = (props) => props.children;

export default Reactaux;